import Icon from '../../Icon/Icon';
import Props from './types';
import S from './IconStyles';

function IconTag({ icon, className, background }: Props):JSX.Element {
  return (
    <S.Wrapper background={background}>
      <Icon iconKey={icon} className={className} />
    </S.Wrapper>
  );
}

export default IconTag;
